import { bus } from './bus.js'
import Settings from './settings.js'
export const toKebabCase = str =>
// #Source https://bit.ly/2neWfJ2
  str &&
  str
    .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
    .map(x => x.toLowerCase())
    .join('-')

export const isDevelopment = () => {
  return new Settings().get({ path: 'env' }) == 'development'
}

export const getInternalAuthToken = () => {
  // let dev_token = 'eyJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjo0LCJleHAiOjE4NzIwNzA0NzZ9.mO_Nj3yQmQydactqv1wPqtEbB4cidO4QTEW-VTaXdbg'
  // let token = isDevelopment() ? dev_token : window.localStorage.getItem('auth')
  // return token
  return window.localStorage.getItem('auth')
}

export const extractStringInsideHtmlTag = (string, tag) => {
  if (string == undefined) {
    return ''
  }
  let results = string.match('<' + tag + '>(.*)</' + tag + '>')
  if (results == undefined) {
    return ''
  }
  return results[1]
}

export const addUniqueToEndOfArray = (array, new_value) => {
  if (array.includes(new_value)) {
    for (let i = 0; i < array.length; i++) {
      let value = array[i]
      if (value == new_value) {
        array.splice(i, 1)
        break
      }
    }
  }
  array.push(new_value)
  return array
}

export const storeInBus = (path, content) => {
  localStorage.setItem(path, content)
}

export const getPositionApplicantCode = id => {
  const settings = new Settings()
  const operationName = settings.get({ path: 'operation_name' })

  if (!operationName || operationName.length === 0) {
    throw new Error('Operation name is not defined.')
  }

  const operationInitial = operationName[0].toUpperCase()
  const idSquared = id ** 2

  return `${operationInitial}-${idSquared}`
}

export const getInternalNotesMinPriority = (resource_type) => {
  if (['Applicant', 'Company'].includes(resource_type)) {
    return 6
  }
  return 5
}

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export const removeObjectArrayDuplicates = (array, identifer) => {
  // https://stackoverflow.com/questions/45439961/remove-duplicate-values-from-an-array-of-objects-in-javascript
  return array.reduce((unique, o) => {
    if (!unique.some(obj => obj[identifer] === o[identifer])) {
      unique.push(o)
    }
    return unique
  }, [])
}

export const lowerCaseFirst = (string) => {
  return string.charAt(0).toLowerCase() + string.slice(1)
}

// An Offer reaches the frontend in TWO different shapes, depending on which
// endpoint served it:
//   Admin::V1::OfferSerializer      -> position via PositionSerializer, which
//                                      `belongs_to :company` => position.company.name
//   Admin::V1::CompanyOfferSerializer -> position via CompanyOfferPositionSerializer,
//                                      which has a FLAT `company_name` and NO
//                                      nested company at all
// Reading the nested path unconditionally threw a TypeError on the second shape,
// and since callers build the title as an ARGUMENT to the modals/create
// mutation (see Message.vue#openModal), the throw aborted the call before the
// modal was ever created — the company-offers message editor simply did nothing
// when clicked. So both shapes are accepted, and anything unresolvable degrades
// to a name instead of an exception.
const getOfferCompanyName = (data) => {
  const position = data.position || {}
  if (position.company && position.company.name) {
    return position.company.name
  }
  if (position.company_name) {
    return position.company_name
  }
  if (data.company && data.company.name) {
    return data.company.name
  }
  return ''
}

const getOfferFullName = (data) => {
  if (data == undefined) {
    return ''
  }
  const applicant = data.applicant || {}
  const position = data.position || {}
  const parts = [
    [applicant.first_name, applicant.last_name].filter(Boolean).join(' '),
    position.title,
    getOfferCompanyName(data)
  ].filter(Boolean)
  if (parts.length > 0) {
    return parts.join(' - ')
  }
  return data.id ? 'הצעה #' + data.id : ''
}

export const getResourceFullName = (params) => {
  if (params.resource_type == 'Applicant') {
    return params.data.first_name + ' ' + params.data.last_name
  }
  if (params.resource_type == 'Position') {
    return params.data.title
  }
  if (params.resource_type == 'Company') {
    return params.data.name
  }
  if (params.resource_type == 'Offer') {
    return getOfferFullName(params.data)
  }
  return ''
}

export const getFromBus = (path) => {
  let response = localStorage[path]
  if (typeof response != 'undefined' && response != 'undefined') {
    return JSON.parse(response)
  }
  // eslint-disable-next-line no-console
  console.log('path: ' + path + ' is undefined in localStorage')
  return ''
}

// Returns true when the browser reports the copy succeeded, false otherwise.
// The temporary input is always removed; errors from execCommand still
// propagate so existing callers that catch them keep working.
export const copyToClipboard = (text) => {
  let input = document.createElement('input')
  document.querySelector('body').append(input)
  try {
    input.setAttribute('value', text)
    input.select()
    return document.execCommand('copy') === true
  } finally {
    input.remove()
  }
}

export const copyToClipboardFromElement = (element) => {
  window.getSelection().removeAllRanges()
  let range = document.createRange()
  range.selectNode(typeof element === 'string' ? document.getElementById(element) : element)
  window.getSelection().addRange(range)
  document.execCommand('copy')
  window.getSelection().removeAllRanges()
}

export const isStringJSON = (string) => {
  try {
    JSON.parse(string)
    return true
  } catch (e) {
    return false
  }
}

export const pseudoEncrypt = (string) => {
  return window.btoa(string)
}

export const openInNewTab = (url, target = '_blank') => {
  // https://stackoverflow.com/questions/4907843/open-a-url-in-a-new-tab-and-not-a-new-window-using-javascript
  var win = window.open(url, target)
  if (win != undefined && win != null) {
    win.focus()
  }
}

export const getOwner = () => {
  let local_owner = JSON.parse(window.localStorage.getItem('owner'))
  if (local_owner == undefined) {
    return {}
  }
  return { ...local_owner, name: local_owner.full_name }
}

export const setOwner = (owner) => {
  window.localStorage.setItem('owner', JSON.stringify(owner))
}

export const toPascalCase = (s) =>
// https://gist.github.com/jacks0n/e0bfb71a48c64fbbd71e5c6e956b17d7
  s.match(/[a-z]+/gi)
    .map(function (word) {
      return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase()
    })
    .join('')

export const isNumeric = (n) =>
  !isNaN(parseFloat(n)) && isFinite(n)

export const updateQueryParams = (url, params) => {
  let new_url = url.toString()
  for (let param in params) {
    let value = params[param]
    if (value == undefined) {
      continue
    }
    new_url = updateQueryStringParameter(new_url, param, value)
  }
  return new_url
}

// https://stackoverflow.com/questions/5999118/how-can-i-add-or-update-a-query-string-parameter
export const updateQueryStringParameter = (url, key, value) => {
  var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i')
  var separator = url.indexOf('?') !== -1 ? '&' : '?'
  if (url.match(re)) {
    return url.replace(re, '$1' + key + '=' + value + '$2')
  } else {
    return url + separator + key + '=' + value
  }
}

export const emit = (event_name, data) => {
  bus.$emit(event_name, data)
}

export const WHATSAPP_INVALID_PHONE_MESSAGE = 'מספר טלפון לא תקין'

// Normalises an Israeli phone number into the `+972XXXXXXXX(X)` form that
// api.whatsapp.com expects. Phone numbers are stored in many shapes (without the
// leading 0, with spaces/dashes, with 972 and a redundant 0, ...). Anything that
// cannot be recognised returns '' so callers can show an explicit error instead
// of rendering an empty href (which opens the current page in a new tab).
export const normalizeIsraeliPhoneForWhatsApp = (rawPhone) => {
  if (rawPhone === undefined || rawPhone === null) return ''
  let digits = String(rawPhone).trim().replace(/[\s\-().\u200e\u200f\u202a-\u202e\u2066-\u2069]/g, '')
  if (digits.startsWith('+')) digits = digits.substring(1)
  else if (digits.startsWith('00972')) digits = digits.substring(2)
  if (!/^\d+$/.test(digits)) return ''
  let national = digits
  if (national.startsWith('972') && national.length >= 11) national = national.substring(3)
  if (national.startsWith('0')) national = national.substring(1)
  // mobile 5X / VoIP 7X: 9 digits; landline 2,3,4,8,9: 8 digits
  if (/^[57]\d{8}$/.test(national) || /^[23489]\d{7}$/.test(national)) {
    return '+972' + national
  }
  return ''
}

export const getWhatsAppLink = (params) => {
  const phone = normalizeIsraeliPhoneForWhatsApp(params.phone_number)
  if (!phone) return ''
  params.phone_number = phone
  return getWhatsAppLinkRecipe(params)
}

export const getWhatsAppLinkRecipe = (params) => {
  let text = params.text == undefined ? ' ' : params.text
  return 'https://api.whatsapp.com/send?phone=' + encodeURIComponent(params.phone_number) + '&text=' + encodeURIComponent(text)
}

export const getHebrewLetters = () => {
  return [
    'א',
    'ב',
    'ג',
    'ד',
    'ה',
    'ו',
    'ז',
    'ח',
    'ט',
    'י',
    'כ',
    'ל',
    'מ',
    'נ',
    'ס',
    'ע',
    'פ',
    'צ',
    'ק',
    'ר',
    'ש',
    'ת',
    'ן',
    'ם',
    'ך',
    'ף',
    'ץ'
  ]
}

export const getEnglishLetters = () => {
  return [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z'
  ]
}

// https://stackoverflow.com/questions/1349404/generate-random-string-characters-in-javascript
export const getRandomString = (params) => (Math.random() + 1).toString(36).substring(2, 2 + params.length)

export const getPropertyFromPathSafely = (params) => {
  try {
    return getPropertyFromPath(params)
  } catch {
    return undefined
  }
}

export const getPropertyFromPath = (params) => {
  // https://stackoverflow.com/questions/359788/how-to-execute-a-javascript-function-when-i-have-its-name-as-a-string
  let context = params.context
  let path = params.path
  var namespaces = path.split('.')
  for (var i = 0; i < namespaces.length; i++) {
    context = context[namespaces[i]]
  }
  return context
}

export const getDomain = () => {
  let data = window.location.href
  var a = document.createElement('a')
  a.href = data
  return a.hostname
}

export const getVetted = (applicant) => {
  const { applicant_status: status } = applicant
  if (status === 'unvetted') {
    return ' (UNVETTED)'
  }
  return ''
}

// הקשר המועמד שנשלח למודל המשרה (ModalPosition) כדי שיציג ליד כל כישור את מה
// שהמועמד סיפר עליו בשיחה עם הצ'אטבוט. בלי מועמד — אובייקט ריק, והמודל נפתח
// בדיוק כמו קודם.
// resource_id הוא מזהה ה-Applicant ב-rebase; id הוא של רשומת ה-user שמעליו.
export const applicantModalContext = (applicant) => {
  if (!applicant) return {}
  const applicant_id = applicant.resource_id || applicant.id
  if (!applicant_id) return {}
  return {
    applicant_id,
    applicant_name: [applicant.first_name, applicant.last_name].filter(Boolean).join(' ')
  }
}

export default {
  toPascalCase,
  toKebabCase,
  getVetted,
  applicantModalContext,
  getRandomString,
  isNumeric,
  getInternalAuthToken,
  updateQueryParams,
  getPropertyFromPath,
  getDomain,
  storeInBus,
  getFromBus,
  emit,
  getWhatsAppLink,
  normalizeIsraeliPhoneForWhatsApp,
  getOwner,
  setOwner,
  getHebrewLetters,
  getEnglishLetters,
  lowerCaseFirst,
  pseudoEncrypt,
  openInNewTab,
  isStringJSON,
  copyToClipboard,
  copyToClipboardFromElement,
  getResourceFullName,
  removeObjectArrayDuplicates,
  isDevelopment,
  getInternalNotesMinPriority,
  getPositionApplicantCode,
  extractStringInsideHtmlTag,
  addUniqueToEndOfArray,
  capitalizeFirstLetter
}
